import { createFileRoute } from '@tanstack/react-router';

import { OverviewPage } from '@/features/collections';
import { currentPeriod } from '@/shared/lib/dates';

export const Route = createFileRoute('/_app/collections/')({
  component: function CollectionsOverview() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <OverviewPage
        period={search.period ?? currentPeriod()}
        bank={search.bank}
        onScopeChange={(patch) => void navigate({ search: (prev) => ({ ...prev, ...patch }) })}
      />
    );
  },
});
